export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('C:/tmp/prosper-deploy/src/views/index.vue'),
    /* no children */
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: 'dashboard',
        name: '/admin/dashboard',
        component: () => import('C:/tmp/prosper-deploy/src/views/admin/dashboard.vue'),
        /* no children */
      },
      {
        path: 'tenants',
        /* internal name: '/admin/tenants' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/tenants/',
            component: () => import('C:/tmp/prosper-deploy/src/views/admin/tenants/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: '/admin/tenants/[id]' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: '/admin/tenants/[id]/edit',
                component: () => import('C:/tmp/prosper-deploy/src/views/admin/tenants/[id]/edit.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/administradoras',
    /* internal name: '/administradoras' */
    /* no component */
    children: [
      {
        path: '',
        name: '/administradoras/',
        component: () => import('C:/tmp/prosper-deploy/src/views/administradoras/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/administradoras/[id]',
        component: () => import('C:/tmp/prosper-deploy/src/views/administradoras/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/alertas',
    /* internal name: '/alertas' */
    /* no component */
    children: [
      {
        path: '',
        name: '/alertas/',
        component: () => import('C:/tmp/prosper-deploy/src/views/alertas/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/alertas/[id]',
        component: () => import('C:/tmp/prosper-deploy/src/views/alertas/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/api-tokens',
    /* internal name: '/api-tokens' */
    /* no component */
    children: [
      {
        path: '',
        name: '/api-tokens/',
        component: () => import('C:/tmp/prosper-deploy/src/views/api-tokens/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/app',
    name: '/app',
    component: () => import('C:/tmp/prosper-deploy/src/views/app.vue'),
    /* no children */
  },
  {
    path: '/campo',
    name: '/campo',
    component: () => import('C:/tmp/prosper-deploy/src/views/campo.vue'),
    children: [
      {
        path: '',
        name: '/campo/',
        component: () => import('C:/tmp/prosper-deploy/src/views/campo/index.vue'),
        /* no children */
      },
      {
        path: 'central',
        name: '/campo/central',
        component: () => import('C:/tmp/prosper-deploy/src/views/campo/central.vue'),
        /* no children */
      },
      {
        path: 'login',
        name: '/campo/login',
        component: () => import('C:/tmp/prosper-deploy/src/views/campo/login.vue'),
        /* no children */
      },
      {
        path: 'ordens',
        /* internal name: '/campo/ordens' */
        /* no component */
        children: [
          {
            path: '',
            name: '/campo/ordens/',
            component: () => import('C:/tmp/prosper-deploy/src/views/campo/ordens/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'perfil',
        name: '/campo/perfil',
        component: () => import('C:/tmp/prosper-deploy/src/views/campo/perfil.vue'),
        /* no children */
      },
      {
        path: 'predio',
        /* internal name: '/campo/predio' */
        /* no component */
        children: [
          {
            path: ':id',
            /* internal name: '/campo/predio/[id]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/campo/predio/[id]/',
                component: () => import('C:/tmp/prosper-deploy/src/views/campo/predio/[id]/index.vue'),
                /* no children */
              },
              {
                path: 'concluido',
                name: '/campo/predio/[id]/concluido',
                component: () => import('C:/tmp/prosper-deploy/src/views/campo/predio/[id]/concluido.vue'),
                /* no children */
              },
              {
                path: 'leitura',
                /* internal name: '/campo/predio/[id]/leitura' */
                /* no component */
                children: [
                  {
                    path: ':medidor',
                    name: '/campo/predio/[id]/leitura/[medidor]',
                    component: () => import('C:/tmp/prosper-deploy/src/views/campo/predio/[id]/leitura/[medidor].vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'rota',
        /* internal name: '/campo/rota' */
        /* no component */
        children: [
          {
            path: '',
            name: '/campo/rota/',
            component: () => import('C:/tmp/prosper-deploy/src/views/campo/rota/index.vue'),
            /* no children */
          },
          {
            path: ':rotaId',
            name: '/campo/rota/[rotaId]',
            component: () => import('C:/tmp/prosper-deploy/src/views/campo/rota/[rotaId].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/central',
    /* internal name: '/central' */
    /* no component */
    children: [
      {
        path: '',
        name: '/central/',
        component: () => import('C:/tmp/prosper-deploy/src/views/central/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/concentradores',
    /* internal name: '/concentradores' */
    /* no component */
    children: [
      {
        path: '',
        name: '/concentradores/',
        component: () => import('C:/tmp/prosper-deploy/src/views/concentradores/index.vue'),
        /* no children */
      },
      {
        path: 'AepioPanel',
        name: '/concentradores/AepioPanel',
        component: () => import('C:/tmp/prosper-deploy/src/views/concentradores/AepioPanel.vue'),
        /* no children */
      },
      {
        path: 'AquametricPanel',
        name: '/concentradores/AquametricPanel',
        component: () => import('C:/tmp/prosper-deploy/src/views/concentradores/AquametricPanel.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/condominios',
    /* internal name: '/condominios' */
    /* no component */
    children: [
      {
        path: '',
        name: '/condominios/',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/condominios/[id]',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/[id].vue'),
        children: [
          {
            path: 'edit',
            name: '/condominios/[id]/edit',
            component: () => import('C:/tmp/prosper-deploy/src/views/condominios/[id]/edit.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'AlertasConfig',
        name: '/condominios/AlertasConfig',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/AlertasConfig.vue'),
        /* no children */
      },
      {
        path: 'AnaliseConsumo',
        name: '/condominios/AnaliseConsumo',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/AnaliseConsumo.vue'),
        /* no children */
      },
      {
        path: 'BlocosManager',
        name: '/condominios/BlocosManager',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/BlocosManager.vue'),
        /* no children */
      },
      {
        path: 'ContasConcessionaria',
        name: '/condominios/ContasConcessionaria',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/ContasConcessionaria.vue'),
        /* no children */
      },
      {
        path: 'ContatosManager',
        name: '/condominios/ContatosManager',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/ContatosManager.vue'),
        /* no children */
      },
      {
        path: 'create',
        name: '/condominios/create',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/create.vue'),
        /* no children */
      },
      {
        path: 'CrmAtividades',
        name: '/condominios/CrmAtividades',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/CrmAtividades.vue'),
        /* no children */
      },
      {
        path: 'EquipamentosCondominio',
        name: '/condominios/EquipamentosCondominio',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/EquipamentosCondominio.vue'),
        /* no children */
      },
      {
        path: 'LeiturasDetalhe',
        name: '/condominios/LeiturasDetalhe',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/LeiturasDetalhe.vue'),
        /* no children */
      },
      {
        path: 'MetodologiasVinculo',
        name: '/condominios/MetodologiasVinculo',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/MetodologiasVinculo.vue'),
        /* no children */
      },
      {
        path: 'MigrarTecnologia',
        name: '/condominios/MigrarTecnologia',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/MigrarTecnologia.vue'),
        /* no children */
      },
      {
        path: 'ParametrosFluido',
        name: '/condominios/ParametrosFluido',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/ParametrosFluido.vue'),
        /* no children */
      },
      {
        path: 'RelatorioPainel',
        name: '/condominios/RelatorioPainel',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/RelatorioPainel.vue'),
        /* no children */
      },
      {
        path: 'RelatoriosConfig',
        name: '/condominios/RelatoriosConfig',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/RelatoriosConfig.vue'),
        /* no children */
      },
      {
        path: 'SindicosManager',
        name: '/condominios/SindicosManager',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/SindicosManager.vue'),
        /* no children */
      },
      {
        path: 'SituacaoCondominio',
        name: '/condominios/SituacaoCondominio',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/SituacaoCondominio.vue'),
        /* no children */
      },
      {
        path: 'UsuariosManager',
        name: '/condominios/UsuariosManager',
        component: () => import('C:/tmp/prosper-deploy/src/views/condominios/UsuariosManager.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/config',
    /* internal name: '/config' */
    /* no component */
    children: [
      {
        path: '',
        name: '/config/',
        component: () => import('C:/tmp/prosper-deploy/src/views/config/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/contratos',
    /* internal name: '/contratos' */
    /* no component */
    children: [
      {
        path: '',
        name: '/contratos/',
        component: () => import('C:/tmp/prosper-deploy/src/views/contratos/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dashboard',
    name: '/dashboard',
    component: () => import('C:/tmp/prosper-deploy/src/views/dashboard.vue'),
    /* no children */
  },
  {
    path: '/design-system',
    /* internal name: '/design-system' */
    /* no component */
    children: [
      {
        path: '',
        name: '/design-system/',
        component: () => import('C:/tmp/prosper-deploy/src/views/design-system/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/equipe',
    /* internal name: '/equipe' */
    /* no component */
    children: [
      {
        path: '',
        name: '/equipe/',
        component: () => import('C:/tmp/prosper-deploy/src/views/equipe/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/faturamento',
    /* internal name: '/faturamento' */
    /* no component */
    children: [
      {
        path: '',
        name: '/faturamento/',
        component: () => import('C:/tmp/prosper-deploy/src/views/faturamento/index.vue'),
        /* no children */
      },
      {
        path: 'gerar',
        name: '/faturamento/gerar',
        component: () => import('C:/tmp/prosper-deploy/src/views/faturamento/gerar.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/faturas',
    /* internal name: '/faturas' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/faturas/[id]',
        component: () => import('C:/tmp/prosper-deploy/src/views/faturas/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/importar',
    /* internal name: '/importar' */
    /* no component */
    children: [
      {
        path: '',
        name: '/importar/',
        component: () => import('C:/tmp/prosper-deploy/src/views/importar/index.vue'),
        /* no children */
      },
      {
        path: 'MigracaoSeuconsumo',
        name: '/importar/MigracaoSeuconsumo',
        component: () => import('C:/tmp/prosper-deploy/src/views/importar/MigracaoSeuconsumo.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/integracoes',
    /* internal name: '/integracoes' */
    /* no component */
    children: [
      {
        path: '',
        name: '/integracoes/',
        component: () => import('C:/tmp/prosper-deploy/src/views/integracoes/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/leituras',
    /* internal name: '/leituras' */
    /* no component */
    children: [
      {
        path: '',
        name: '/leituras/',
        component: () => import('C:/tmp/prosper-deploy/src/views/leituras/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/leituras/[id]' */
        /* no component */
        children: [
          {
            path: 'edit',
            name: '/leituras/[id]/edit',
            component: () => import('C:/tmp/prosper-deploy/src/views/leituras/[id]/edit.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'create',
        name: '/leituras/create',
        component: () => import('C:/tmp/prosper-deploy/src/views/leituras/create.vue'),
        /* no children */
      },
      {
        path: 'lista',
        /* internal name: '/leituras/lista' */
        /* no component */
        children: [
          {
            path: '',
            name: '/leituras/lista/',
            component: () => import('C:/tmp/prosper-deploy/src/views/leituras/lista/index.vue'),
            /* no children */
          },
          {
            path: ':condominio',
            /* internal name: '/leituras/lista/[condominio]' */
            /* no component */
            children: [
              {
                path: ':ciclo',
                name: '/leituras/lista/[condominio]/[ciclo]',
                component: () => import('C:/tmp/prosper-deploy/src/views/leituras/lista/[condominio]/[ciclo].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'painel',
        name: '/leituras/painel',
        component: () => import('C:/tmp/prosper-deploy/src/views/leituras/painel.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/leituristas',
    /* internal name: '/leituristas' */
    /* no component */
    children: [
      {
        path: '',
        name: '/leituristas/',
        component: () => import('C:/tmp/prosper-deploy/src/views/leituristas/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/leituristas/[id]' */
        /* no component */
        children: [
          {
            path: 'edit',
            name: '/leituristas/[id]/edit',
            component: () => import('C:/tmp/prosper-deploy/src/views/leituristas/[id]/edit.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'create',
        name: '/leituristas/create',
        component: () => import('C:/tmp/prosper-deploy/src/views/leituristas/create.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('C:/tmp/prosper-deploy/src/views/login.vue'),
    /* no children */
  },
  {
    path: '/logistica',
    /* internal name: '/logistica' */
    /* no component */
    children: [
      {
        path: '',
        name: '/logistica/',
        component: () => import('C:/tmp/prosper-deploy/src/views/logistica/index.vue'),
        /* no children */
      },
      {
        path: 'operacoes',
        name: '/logistica/operacoes',
        component: () => import('C:/tmp/prosper-deploy/src/views/logistica/operacoes.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/medidores',
    /* internal name: '/medidores' */
    /* no component */
    children: [
      {
        path: '',
        name: '/medidores/',
        component: () => import('C:/tmp/prosper-deploy/src/views/medidores/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/medidores/[id]',
        component: () => import('C:/tmp/prosper-deploy/src/views/medidores/[id].vue'),
        children: [
          {
            path: 'edit',
            name: '/medidores/[id]/edit',
            component: () => import('C:/tmp/prosper-deploy/src/views/medidores/[id]/edit.vue'),
            /* no children */
          },
          {
            path: 'trocar',
            name: '/medidores/[id]/trocar',
            component: () => import('C:/tmp/prosper-deploy/src/views/medidores/[id]/trocar.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'create',
        name: '/medidores/create',
        component: () => import('C:/tmp/prosper-deploy/src/views/medidores/create.vue'),
        /* no children */
      },
      {
        path: 'MedidoresAgrupado',
        name: '/medidores/MedidoresAgrupado',
        component: () => import('C:/tmp/prosper-deploy/src/views/medidores/MedidoresAgrupado.vue'),
        /* no children */
      },
      {
        path: 'MedidoresArvore',
        name: '/medidores/MedidoresArvore',
        component: () => import('C:/tmp/prosper-deploy/src/views/medidores/MedidoresArvore.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/mensalidades',
    /* internal name: '/mensalidades' */
    /* no component */
    children: [
      {
        path: '',
        name: '/mensalidades/',
        component: () => import('C:/tmp/prosper-deploy/src/views/mensalidades/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/metodologias',
    /* internal name: '/metodologias' */
    /* no component */
    children: [
      {
        path: '',
        name: '/metodologias/',
        component: () => import('C:/tmp/prosper-deploy/src/views/metodologias/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/metodologias/[id]' */
        /* no component */
        children: [
          {
            path: 'edit',
            name: '/metodologias/[id]/edit',
            component: () => import('C:/tmp/prosper-deploy/src/views/metodologias/[id]/edit.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/monitoramento',
    /* internal name: '/monitoramento' */
    /* no component */
    children: [
      {
        path: '',
        name: '/monitoramento/',
        component: () => import('C:/tmp/prosper-deploy/src/views/monitoramento/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/morador',
    /* internal name: '/morador' */
    /* no component */
    children: [
      {
        path: '',
        name: '/morador/',
        component: () => import('C:/tmp/prosper-deploy/src/views/morador/index.vue'),
        /* no children */
      },
      {
        path: 'entrar',
        name: '/morador/entrar',
        component: () => import('C:/tmp/prosper-deploy/src/views/morador/entrar.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/ordens',
    /* internal name: '/ordens' */
    /* no component */
    children: [
      {
        path: '',
        name: '/ordens/',
        component: () => import('C:/tmp/prosper-deploy/src/views/ordens/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/ordens/[id]',
        component: () => import('C:/tmp/prosper-deploy/src/views/ordens/[id].vue'),
        children: [
          {
            path: 'edit',
            name: '/ordens/[id]/edit',
            component: () => import('C:/tmp/prosper-deploy/src/views/ordens/[id]/edit.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'create',
        name: '/ordens/create',
        component: () => import('C:/tmp/prosper-deploy/src/views/ordens/create.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/processamento',
    /* internal name: '/processamento' */
    /* no component */
    children: [
      {
        path: '',
        name: '/processamento/',
        component: () => import('C:/tmp/prosper-deploy/src/views/processamento/index.vue'),
        /* no children */
      },
      {
        path: ':sistema',
        name: '/processamento/[sistema]',
        component: () => import('C:/tmp/prosper-deploy/src/views/processamento/[sistema].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/profile',
    /* internal name: '/profile' */
    /* no component */
    children: [
      {
        path: '',
        name: '/profile/',
        component: () => import('C:/tmp/prosper-deploy/src/views/profile/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/relatorios',
    /* internal name: '/relatorios' */
    /* no component */
    children: [
      {
        path: '',
        name: '/relatorios/',
        component: () => import('C:/tmp/prosper-deploy/src/views/relatorios/index.vue'),
        /* no children */
      },
      {
        path: 'exportacao',
        name: '/relatorios/exportacao',
        component: () => import('C:/tmp/prosper-deploy/src/views/relatorios/exportacao.vue'),
        /* no children */
      },
      {
        path: 'fechamento',
        name: '/relatorios/fechamento',
        component: () => import('C:/tmp/prosper-deploy/src/views/relatorios/fechamento.vue'),
        /* no children */
      },
      {
        path: 'gerar',
        name: '/relatorios/gerar',
        component: () => import('C:/tmp/prosper-deploy/src/views/relatorios/gerar.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/sindico',
    /* internal name: '/sindico' */
    /* no component */
    children: [
      {
        path: '',
        name: '/sindico/',
        component: () => import('C:/tmp/prosper-deploy/src/views/sindico/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/sindicos',
    /* internal name: '/sindicos' */
    /* no component */
    children: [
      {
        path: '',
        name: '/sindicos/',
        component: () => import('C:/tmp/prosper-deploy/src/views/sindicos/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/sindicos/[id]' */
        /* no component */
        children: [
          {
            path: 'edit',
            name: '/sindicos/[id]/edit',
            component: () => import('C:/tmp/prosper-deploy/src/views/sindicos/[id]/edit.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'create',
        name: '/sindicos/create',
        component: () => import('C:/tmp/prosper-deploy/src/views/sindicos/create.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/solicitacoes',
    /* internal name: '/solicitacoes' */
    /* no component */
    children: [
      {
        path: '',
        name: '/solicitacoes/',
        component: () => import('C:/tmp/prosper-deploy/src/views/solicitacoes/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/unidades',
    /* internal name: '/unidades' */
    /* no component */
    children: [
      {
        path: '',
        name: '/unidades/',
        component: () => import('C:/tmp/prosper-deploy/src/views/unidades/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/unidades/[id]',
        component: () => import('C:/tmp/prosper-deploy/src/views/unidades/[id].vue'),
        children: [
          {
            path: 'edit',
            name: '/unidades/[id]/edit',
            component: () => import('C:/tmp/prosper-deploy/src/views/unidades/[id]/edit.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'create',
        name: '/unidades/create',
        component: () => import('C:/tmp/prosper-deploy/src/views/unidades/create.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/vazamentos',
    /* internal name: '/vazamentos' */
    /* no component */
    children: [
      {
        path: '',
        name: '/vazamentos/',
        component: () => import('C:/tmp/prosper-deploy/src/views/vazamentos/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/walkby',
    /* internal name: '/walkby' */
    /* no component */
    children: [
      {
        path: '',
        name: '/walkby/',
        component: () => import('C:/tmp/prosper-deploy/src/views/walkby/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

